import { FC } from "react";
import { useTranslation } from "react-i18next";
import type { PriceBreakdown } from "src/Modules/Hotels/hooks/usePriceBreakdown";
import PaymentChip, { PaymentChipRow } from "../PaymentChip/PaymentChip";

const TotalTopCard: FC<{ price: PriceBreakdown }> = ({ price }) => {
  const { t } = useTranslation();
  const currency = price.currency ?? "";

  const summaryRows: PaymentChipRow[] = [
    ...(price.baseFare > 0 ? [{ label: t("Flights.details.summary.faresSubtotal"), total: price.baseFare, currency }] : []),
    ...(price.totalTax > 0 ? [{ label: t("Flights.details.summary.taxesAndFees"), total: price.totalTax, currency }] : []),
    ...(price.addonsTotal > 0 ? [{ label: t("Flights.details.summary.addonsAndExtras"), total: price.addonsTotal, currency }] : []),
  ];

  return (
    <div className="flex flex-col gap-4 rounded-xl">
      <div className="text-lg text-font-default font-semibold">{t("Flights.details.summary.priceSummary")}</div>
      <PaymentChip rows={summaryRows} title={t("Flights.details.summary.fareBreakdown")} />
    </div>
  );
};

export default TotalTopCard;
